import React from 'react';
import { Box, Typography, Grid } from '@material-ui/core';
import Wheelhouse from '../../../images/Wheelhouse.svg';
import Alvino from '../../../images/Alvino.svg';
import Narrative from '../../../images/Narrative.svg';
import TalkRemit from '../../../images/TalkRemit.svg';
import Leadiq from '../../../images/Leadiq.svg';
import Neudesic from '../../../images/Neudesic.svg';

const images = [
  {
    index: 1,
    alt: 'Wheelhouse',
    src: Wheelhouse,
  },
  {
    index: 2,
    alt: 'Alvino',
    src: Alvino,
  },
  {
    index: 3,
    alt: 'Narrative',
    src: Narrative,
  },
  {
    index: 4,
    alt: 'TalkRemit',
    src: TalkRemit,
  },
  {
    index: 5,
    alt: 'Leadiq',
    src: Leadiq,
  },
  {
    index: 6,
    alt: 'Neudesic',
    src: Neudesic,
  },
];

const TrustedCompaniesList = ({
  headingProps,
  wrapperBoxProps,
  itemGridProps,
}) => {
  return (
    <Box {...wrapperBoxProps}>
      <Typography variant="h3" {...headingProps}>
        Companies that trust us for remote hiring & global payroll
      </Typography>
      <Box marginTop={3}>
        <Grid container spacing={2}>
          {images.map(image => (
            <Grid item key={image.index} sm={2} md={5} {...itemGridProps}>
              <Box
                textAlign="center"
                paddingX={4}
                paddingY={2}
                bgcolor="#ffffff"
                borderRadius={4}
              >
                <img src={image.src} alt={image.alt} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default TrustedCompaniesList;
